import { getOrderPeriod, getOrdersTotal, getPostingInfo, isOrderActive } from "@/functions/billing";
import { calcVat } from "@/functions/calc-functions";
import { formatAmount, formatStringDateOnly } from "@/functions/format-functions";
import { IsCandidateOrder, IsPostingOrder } from "@/views/admin-billing/admin-billing-types";
import { Orders } from "@/views/billing/billing-types";
import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
    props: {
        orders: {
            type: Object as PropType<Orders>,
        },
        loaded: {
            type: Boolean,
            default: false,
        },
    },
    setup() {

        return {
            IsPostingOrder,
            getPostingInfo,
            IsCandidateOrder,
            isOrderActive,
            formatAmount,
            getOrdersTotal,
            formatStringDateOnly,
            getOrderPeriod,
            calcVat,
            
        };
    }
});